import { t } from 'i18next';
import React from 'react';

import mobilePhone from '@/assets/mobile-phone.png';
import { EPRequestTierConfirmationModal } from './styled';

const EPRequestTierModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => (
  <EPRequestTierConfirmationModal open={isOpen} width={400} footer={null} centered onCancel={onClose} zIndex={1030}>
    <div className="request-tier-confirmation-modal">
      <img src={mobilePhone} alt="mobile-phone" className="mobile-phone" />
      <div>
        <div>{t('requestTierConfirmationMessageLine1')}</div>
        <div>{t('requestTierConfirmationMessageLine2')}</div>
      </div>
    </div>
  </EPRequestTierConfirmationModal>
);

export default EPRequestTierModal;
